var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup-buttons",class:_vm.isPopup ? 'popup-buttons--toBottom' : 'popup-buttons--normal2'},[_c('button',{staticClass:"popup-button",on:{"click":_vm.cancel}},[_vm._v("取消")]),_c('button',{staticClass:"popup-button",class:_vm.submitButtonClass,on:{"click":_vm.submit}},[_vm._v("確定")])])
}
var staticRenderFns = []

export { render, staticRenderFns }